import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './plugins/vuetify-money.js';
import './plugins/vuetify-currency-field.js';

import './scss/style.scss';

import moment from 'moment';
import i18n from './i18n';
import VueCookies from 'vue-cookies';

Vue.config.productionTip = false;

Vue.filter('formatDate', function(value: any) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY');
  }
});

Vue.filter('formatDateTime', function(value: any) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm:ss');
  }
});

Vue.use(VueCookies);
Vue.$cookies.config('1y');

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app');
